export const ALL_TEST_CASES = 'All Test Cases';

export const Flags = {
  addTestCaseToFolder: {
    success: (numberOfTestCases: number) => {
      return numberOfTestCases === 1
        ? `1 QAlity test case has been added to folder`
        : `${numberOfTestCases} QAlity test cases have been added to the folder`;
    },
    error: (numberOfTestCases: number) => {
      return numberOfTestCases
        ? 'Sorry, we could not add the test case to the folder. Please try again.'
        : 'Sorry, we could not add test cases to the folder. Please try again.';
    },
    warning: () => {
      return 'You need “edit issues” permission level in a folder home project to move issues.';
    },
  },
};
